const PROMPTS = [
  "What made you smile today?",
  "Which small thing today deserves to be remembered?",
  "What's one thing you did well?",
  "Who did you think about today, and why?",
  "What are you grateful for right now?",
  "What was the loudest thought in your head today?",
  "Describe the light this evening.",
  "What surprised you today?",
  "What have you been avoiding? Just name it.",
  "What did you learn from a mistake this week?",
  "What is your body telling you?",
  "If today had a colour, which one?",
  "What is one kindness you noticed?",
  "What made you laugh?",
  "What are you afraid of admitting?",
  "Name three things that went well.",
  "What are you looking forward to tomorrow?",
  "Write one honest sentence — no editing.",
  "What did you eat that you actually enjoyed?",
  "What did the sky look like today?",
  "Which conversation stayed with you?",
  "What is one thing you did today that your younger self would be proud of?",
  "What are you carrying that isn't yours?",
  "What would today's news headline about you say?",
  "What is one thing you noticed that most people missed?",
  "What is a small ritual that grounded you today?",
  "If you could rewrite one hour of today, which and how?",
  "Who deserves a thank-you note?",
  "What do you want to remember when you're 80?",
  "Describe the way you feel — in three words.",
];

export function promptForToday(date = new Date()) {
  // Deterministic pick per calendar day
  const y = date.getFullYear();
  const m = date.getMonth();
  const d = date.getDate();
  const idx = Math.abs((y * 372 + m * 31 + d) % PROMPTS.length);
  return PROMPTS[idx];
}
